export type OpportunitySection =
  | 'ActionResult'
  | 'Summary'
  | 'Applicants'
  | 'Liabilities'
  | 'Purpose'
  | 'Borrowing Capacity'
  | 'Funds Position'
  | 'Income'
  | 'Assets'
  | 'Product Selection'
  | 'Questionnaire'
  | 'Discussion Notes'
  | 'Documents'
  | 'Refixes'

export type ViolationCategory = 'Servicing';

export type Violation = {
  section: OpportunitySection
  entityId: string | null
  subEntityId: string | null
  message: string
  category?: ViolationCategory
}

export const entityHasViolation = (violations: Violation[], entityId: string) => violations.find(v => v.entityId === entityId);
export const subEntityHasViolation = (violations: Violation[], entityId: string, subEntityId: string) => violations.find(v => v.entityId === entityId && v.subEntityId === subEntityId);
